<template>
  <a href="#" class="store_box" @click.prevent="$emit('invite')">
    <BaseImage
      src="/static/images/store/store_game_icon.svg"
      alt="store invite"
    />

    <div class="flex-column">
      <p class="title">{{ $_translations.value.page_store_item_invite_reward }}</p>
    </div>

    <div class="flex-row">
      <p class="price invite">{{ $_translations.value.page_store_item_invite_invite_friend }}</p>

      <i class="fas fa-chevron-right"></i>
    </div>
  </a>
</template>

<script setup>
import BaseImage from '@/components/image/BaseImage.vue';

defineEmits(['invite']);
</script>
